// Fallback used when the constants store is not yet hydrated (race condition
// at app boot, when fetchConstants() and surveyStore.fetch() run in parallel).
// The mapping is deterministic from the type prefix so we don't need the
// backend constants to colour the card icons correctly.
export function inferGroupTypeFromPrefix(type) {
  if (!type) return null;
  if (type.startsWith("q_") || type === "ai_chat" || type === "ai_chat_v2") return "question";
  if (type.startsWith("m_")) return "message";
  if (type.startsWith("o_")) return "other";
  if (type.startsWith("s_")) return "standard";
  return null;
}

// cards is null (not undefined) for surveys created without cards, so a default parameter is not enough.
export default (cards, typeFinder) => {
  return (cards ?? []).map((card) => ({
    ...card,
    groupType: typeFinder(card.type) || inferGroupTypeFromPrefix(card.type),
  }));
};
